var map = {
	"./Yoyo_3121.jpg": 812,
	"./Yoyo_3206.jpg": 813,
	"./Yoyo_3621.jpg": 814,
	"./Yoyo_4422.jpg": 815,
	"./Yoyo_5521.jpg": 816,
	"./Yoyo_5913.jpg": 817,
	"./Yoyo_6443.jpg": 818,
	"./Yoyo_6611.jpg": 819,
	"./Yoyo_6932.jpg": 820,
	"./Yoyo_8000.jpg": 821,
	"./Yoyo_8220.jpg": 822,
	"./Yoyo_8440.jpg": 823
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 811;